import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Team } from '@/services/team.service'
import { selectSetActiveTeam, useAuthStore } from '@/stores/auth.store'

export function useTeamChange() {
  const queryClient = useQueryClient()
  const setActiveTeam = useAuthStore(selectSetActiveTeam)

  const changeTeam = useCallback(
    async (team: Team) => {
      setActiveTeam(team)
      await queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey
          return !queryKey.includes('/team')
        },
      })
    },
    [setActiveTeam, queryClient]
  )

  return { changeTeam }
}
